import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Heading3(props: ComponentPropsWithoutRef<'h3'>) {
  const { children, ...rest } = props;

  return (
    <Typography
      as="h3"
      variant="body-m"
      weight="medium"
      className="text-grayscale600"
      {...rest}
    >
      {children}
    </Typography>
  );
}
